const createFloatingParallaxOptions = (strStartScroll, strEndScroll, strTranslateY) => ({
  strStartScroll,
  strEndScroll,
  strTranslateY,
});

export default createFloatingParallaxOptions;
